'use client'

import React from 'react'

type Props = {
    side: number
}

const WIDTH = 340
const HEIGHT = 220

export default function CubeChart({ side }: Props) {
    const s = 130
    const ox = 55
    const oy = -40
    const fx = (WIDTH - s - ox) / 2
    const fy = 60

    const A = [fx, fy]
    const B = [fx + s, fy]
    const C = [fx + s, fy + s]
    const D = [fx, fy + s]
    const A2 = [fx + ox, fy + oy]
    const B2 = [fx + s + ox, fy + oy]
    const C2 = [fx + s + ox, fy + s + oy]

    const pts = (arr: number[][]) => arr.map((p) => p.join(',')).join(' ')

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            {/* hidden back edges */}
            <line x1={D[0]} y1={D[1]} x2={D[0] + ox} y2={D[1] + oy} stroke="#9ca3af" strokeWidth={1.5} strokeDasharray="4,3" />
            <line x1={A2[0]} y1={A2[1]} x2={D[0] + ox} y2={D[1] + oy} stroke="#9ca3af" strokeWidth={1.5} strokeDasharray="4,3" />
            <line x1={C2[0]} y1={C2[1]} x2={D[0] + ox} y2={D[1] + oy} stroke="#9ca3af" strokeWidth={1.5} strokeDasharray="4,3" />
            {/* top face */}
            <polygon points={pts([A, B, B2, A2])} fill="#2563eb" opacity={0.12} stroke="#2563eb" strokeWidth={2} />
            {/* right face */}
            <polygon points={pts([B, C, C2, B2])} fill="#2563eb" opacity={0.22} stroke="#2563eb" strokeWidth={2} />
            {/* front face */}
            <polygon points={pts([A, B, C, D])} fill="#2563eb" opacity={0.32} stroke="#2563eb" strokeWidth={2} />
            {/* label */}
            <text x={(A[0] + C[0]) / 2} y={C[1] + 24} fontSize={12} textAnchor="middle" fill="#374151">
                a = {side.toFixed(2)}
            </text>
        </svg>
    )
}
